<!--
 * @Author: Merlin
 * @Date: 2024-03-11 09:59:25
 * @LastEditors: Merlin
 * @LastEditTime: 2024-06-20 16:54:25
 * @Description: 这是自动模式的提示窗口 
-->

<template>
    <ModalTitle class="font-medium text-textFade"
        v-bind="$attrs"
        :model-value="modelValue"
        @update:model-value="emit('update:modelValue', $event)"
        container-class=""
    >
        <template #header>
            <span class="text-[24px] leading-10">
                {{ headerTitle }}
            </span>
        </template>
        <!-- 
            ↑ 顶部元素
            ↓ 正文
        -->
        <div class="max-h-[375px] overflow-y-auto">
            <div v-if="isBlackJack">
                <p class="text-lg text-white mb-2 font-semibold">
                    {{ t.GameBlackJack.tryNew21Title01 }}
                </p>
                <p>
                    {{ t.GameBlackJack.tryNew21Title02 }}
                </p>
            </div>
            <div v-else>
                <p class=" text-lg text-white mb-2 font-semibold">{{ t.AutoModeTitle }}</p>
                <p class="">{{ t.AutoModeSection1 }}</p>
            </div>
            <!-- ↑ 上方标题 -->
            <div>
                <ul class="my-3">
                    <li v-for="(rule, ind) in rulesList" :key="ind" class="text-sm infoDetail relative pl-5 mb-2">
                        <span class="font-semibold text-white">{{ rule.label1 }}</span>
                        <p v-if="isBlackJack">
                            {{ rule.label2 }}
                        </p>
                        <span v-else>
                            {{ ' - ' }}{{ rule.label2 }}
                        </span>
                    </li>
                </ul>
                <div class="last-remark" >
                    <img :src="autoImage" />
                </div>
            </div>
        </div>
        <!-- ↑ 上方正文 -->
        <!-- ↓ 下方底部的插槽 -->
        <template v-slot:footer>
            <div class="w-full">
                <!-- ↓ 特定条件下不显示复选框 -->
                <div class="flex items-center pb-2 -mt-1"
                    v-if="!onPurpose && isBlackJack"
                >
                    <QCheckbox
                        color="green"
                        class="border-[#55657e]"
                        v-model="settingsStore[keyForRecard]" 
                    >
                        <span class="text-white">{{ t.DonNotshowThisAgain }}</span>
                    </QCheckbox>
                </div>
                <!-- ↑ 不再显示的确认框 -->
                <!-- ↓ 按钮 -->
                <div class="flex m-auto w-full">
                    <!-- class="w-full h-[48px]" -->
                    <ButtonThe3DButton
                        fullWidth
                        size="lg"
                        color="blue"
                        @click="onContinueClick"
                        class="text-white"
                    >
                        {{ t.Continue }}
                    </ButtonThe3DButton>
                </div>
            </div>
        </template>
    </ModalTitle>
</template>


<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import autoImage from '~/assets/imgs/auto.webp';
import useSettingsStore from '~/stores/settings';

const settingsStore = useSettingsStore(); 
const t = useTranslation(); 

const props = defineProps({
    gameName: String, 
    modelValue: {
        type: Boolean,
        required: true,
    },
    onPurpose: { // 为 true 表示用户刻意点击查看此窗口 
        type: Boolean,
    },
});
const emit = defineEmits(['update:modelValue']); 
const isBlackJack = computed(() => { 
    const bResult = props.gameName === 'blackjackGame';
    return bResult;
});

const onContinueClick = () => {
    emit('update:modelValue', false)
}


const headerTitle = computed(()=>{
    if (isBlackJack.value){ 
        return t.GameBlackJack.ProMode
    }
    return t.AutoModeBigTitle;
});

const keyForRecard = 'proModePopupDontShow';

const rulesList = computed(()=>{
    if (isBlackJack.value){ 
        return [{
            label1: t.GameBlackJack.PerfectPairs,
            label2: t.GameBlackJack.secondtion01Desc,
        }, {
            label1: t.GameBlackJack.secondtion02Title,
            label2: t.GameBlackJack.secondtion02Desc,
        }];
    }
    return [
        { label1: t.NUMBER_OF_BETS, label2: t.NumberOfBetsDescription },
        { label1: t.STOP_ON_PROFIT, label2: t.StopOnProfitDescription },
        { label1: t.STOP_ON_LOSS, label2: t.StopOnLossDescription },
        { label1: t.MAX_BET_AMOUNT, label2: t.MaxBetAmountDescription },
        { label1: t.ON_WIN, label2: t.OnWinDescription },
        { label1: t.ON_LOSS, label2: t.OnLossDescription },
    ];
});


</script>


<style lang="scss" scoped> 
.infoDetail::before {
    background-color: #93acd3;
    border-radius: 50%;
    content: "";
    height: 3px;
    left: 5px;
    position: absolute;
    top: 9px;
    width: 3px;
}
.last-remark > *:after{
    content: ' ';
}
</style>


